<template>
  <v-container class="grey lighten-5" fluid>
    <v-row>
        <v-col cols="12" md="3" xl="2">
          <modal-add-company ref="addCompanyDialog" :redirect="true"/>
          <modal-send-sms ref="sendSmsDialog"/>
          <modal-send-email ref="sendEmailDialog"/>
          <modal-add-note ref="addNoteDialog"/>
          <v-btn @click="showAddCompanyModal" color="blue" class="mb-2" block>Utwórz firmę</v-btn>
          <v-card>
            <v-card-title>
              Filtry
            </v-card-title>
            <v-card-text>
              <CompaniesFilters></CompaniesFilters>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="9" xl="10">
      <v-tabs v-model="tab" @change="onTabChange">
        <v-tab>
          Zbierający
        </v-tab>
        <v-tab>
          Wytwarzający
        </v-tab>
        <v-tab>
          Osoby fizyczne
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col>
              <v-card>
                <v-card-title>
                  Lista firm
                </v-card-title>
                <v-card-text>
                  <data-table
                      :headers="headers"
                      :items="companies"
                      :options.sync="options"
                      :server-items-length="total"
                      :loading="loading"
                      class="row-pointer"
                      @click:row="(company) => $router.push({name: 'company-details', params: { id: company.id }}).catch(()=>{})"
                  >
                    <template v-slot:item.supervisor="{ item }">
                          <span v-if="item.supervisor" :style="'padding: 0.5rem; display:block; background:' + item.supervisor.color">
                            {{ item.supervisor.name }} {{ item.supervisor.surname }} ({{ item.supervisor.email }})
                          </span>
                      <span v-else>
                            -
                          </span>
                    </template>
                    <template v-slot:item.premium="{ item }">
                      {{ getIsPremiumName(item.premium) }}
                    </template>
                    <template v-slot:item.name="{ item }">
                      {{ item.name}}
                      <v-tooltip top color="primary" v-if="item.notes.length">
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip
                                v-bind="attrs"
                                v-on="on"
                                label
                                small
                                color="primary"
                            >
                            ?
                          </v-chip>
                        </template>
                        <div>
                          <p v-for="note in item.notes" :key="note">{{ note.note }}</p>
                        </div>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.partner="{ item }">
                      {{ getIsPartnerName(item.partner) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn class="blue mt-2 mr-2" @click.stop="sendEmail(item, $event)" depressed>
                        <v-icon dark>
                          mdi-email
                        </v-icon>
                      </v-btn>
                      <v-btn class="blue mt-2 mr-2" @click.stop="sendSms(item, $event)" depressed>
                        <v-icon dark>
                          mdi-phone
                        </v-icon>
                      </v-btn>
                      <v-btn class="red mt-2" @click.stop="disable(item, $event)" depressed>
                        <v-icon dark>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                  </data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col>
              <v-card>
                <v-card-title>
                  Lista firm
                </v-card-title>
                <v-card-text>
                  <data-table
                      :headers="headers"
                      :items="companies"
                      :options.sync="options"
                      :server-items-length="total"
                      :loading="loading"
                      class="row-pointer"
                      @click:row="(company) => $router.push({name: 'company-details', params: { id: company.id }}).catch(()=>{})"
                  >
                    <template v-slot:item.supervisor="{ item }">
                          <span v-if="item.supervisor" :style="'padding: 0.5rem; display:block; background:' + item.supervisor.color">
                            {{ item.supervisor.name }} {{ item.supervisor.surname }} ({{ item.supervisor.email }})
                          </span>
                      <span v-else>
                            -
                          </span>
                    </template>
                    <template v-slot:item.premium="{ item }">
                      {{ getIsPremiumName(item.premium) }}
                    </template>
                    <template v-slot:item.name="{ item }">
                      {{ item.name}}
                      <v-tooltip top color="primary" v-if="item.notes.length">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                              v-bind="attrs"
                              v-on="on"
                              label
                              small
                              color="primary"
                          >
                            ?
                          </v-chip>
                        </template>
                        <div>
                          <p v-for="note in item.notes" :key="note">{{ note.note }}</p>
                        </div>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.partner="{ item }">
                      {{ getIsPartnerName(item.partner) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn class="blue mt-2 mr-2" @click.stop="sendEmail(item, $event)" depressed>
                        <v-icon dark>
                          mdi-email
                        </v-icon>
                      </v-btn>
                      <v-btn class="blue mt-2 mr-2" @click.stop="sendSms(item, $event)" depressed>
                        <v-icon dark>
                          mdi-phone
                        </v-icon>
                      </v-btn>
                      <v-btn class="red mt-2" @click.stop="disable(item, $event)" depressed>
                        <v-icon dark>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                  </data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col>
              <v-card>
                <v-card-title>
                  Lista firm
                </v-card-title>
                <v-card-text>
                  <data-table
                      :headers="headers"
                      :items="companies"
                      :options.sync="options"
                      :server-items-length="total"
                      :loading="loading"
                      class="row-pointer"
                      @click:row="(company) => $router.push({name: 'company-details', params: { id: company.id }}).catch(()=>{})"
                  >
                    <template v-slot:item.supervisor="{ item }">
                          <span v-if="item.supervisor" :style="'padding: 0.5rem; display:block; background:' + item.supervisor.color">
                            {{ item.supervisor.name }} {{ item.supervisor.surname }} ({{ item.supervisor.email }})
                          </span>
                      <span v-else>
                            -
                          </span>
                    </template>
                    <template v-slot:item.premium="{ item }">
                      {{ getIsPremiumName(item.premium) }}
                    </template>
                    <template v-slot:item.name="{ item }">
                      {{ item.name}}
                      <v-tooltip top color="primary" v-if="item.notes.length">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                              v-bind="attrs"
                              v-on="on"
                              label
                              small
                              color="primary"
                          >
                            ?
                          </v-chip>
                        </template>
                        <div>
                          <p v-for="note in item.notes" :key="note">{{ note.note }}</p>
                        </div>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.partner="{ item }">
                      {{ getIsPartnerName(item.partner) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn class="blue mt-2 mr-2" @click.stop="sendEmail(item, $event)" depressed>
                        <v-icon dark>
                          mdi-email
                        </v-icon>
                      </v-btn>
                      <v-btn class="blue mt-2 mr-2" @click.stop="sendSms(item, $event)" depressed>
                        <v-icon dark>
                          mdi-phone
                        </v-icon>
                      </v-btn>
                      <v-btn class="red mt-2" @click.stop="disable(item, $event)" depressed>
                        <v-icon dark>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                  </data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import api from '../services/api';
    import {getYesNoName} from '@/enums/YesNo';
    import CompaniesFilters from "@/components/companies/CompaniesFilters";
    import DataTable from "@/components/data-table/DataTable";
    import filters from "@/mixins/filters";
    import {getDatatableParams, setDatatableOptions} from '@/utils/helpers';
    import ModalAddCompany from "@/components/ModalAddCompany.vue";
    import ModalSendSms from "@/components/ModalSendSms.vue";
    import ModalSendEmail from "@/components/ModalSendEmail.vue";
    import ModalAddNote from "@/components/ModalAddNote.vue";

    export default {
        mixins: [
            filters,
        ],
        components: {
          ModalAddNote,
          ModalSendEmail,
          ModalSendSms,
          ModalAddCompany,
            CompaniesFilters,
            DataTable,
        },
        data() {
            return {
                total: 0,
                companies: [],
                loading: false,
                options: {},
                headers: [
                    { text: 'Nazwa', value: 'name', sortable: false },
                    { text: 'Opiekun', value: 'supervisor', sortable: false },
                    { text: 'NIP', value: 'nip', sortable: false },
                    { text: 'Kod pocztowy', value: 'address.postalCode', sortable: false },
                    { text: 'Miasto', value: 'address.city', sortable: false },
                    { text: 'BDO', value: 'bdo', sortable: false },
                    { text: 'Akcje', value: 'actions', sortable: false, },
                ],
                filters: {},
                tab: null,
                companyType: null,
            }
        },
        mounted() {
            const self = this;

            this.$root.$on('companies.resetPage', () => {
              this.options.page = 1;
              setDatatableOptions.call(this);
            });
            this.$root.$on('companies.load', (options) => {
                self.load(options);
            });
        },
        watch: {
            options: {
                handler () {
                    this.load();
                    setDatatableOptions.call(this);
                },
                deep: true,
            },
        },
        methods: {
          onTabChange() {
            let tabValue = 0;
              switch (this.tab) {
                case 0:
                  tabValue = 'C';
                  break;
                case 1:
                  tabValue = 'E';
                  break;
                case 2:
                  tabValue = 'N';
                  break;
              }
              this.filters.type = tabValue;
              this.companyType = tabValue;
              this.load();
            },
            appendFilters(params, filters) {
                if (!(filters instanceof Object)) {
                    return;
                }

                this.appendStringFilterIfNonEmpty(params, 'type', filters.type);
                this.appendStringFilterIfNonEmpty(params, 'status', filters.status);
                this.appendIntFilterIfNonEmpty(params, 'supervisor', filters.supervisor);
                this.appendStringFilterIfNonEmpty(params, 'companyName', filters.companyName);
                this.appendStringFilterIfNonEmpty(params, 'nip', filters.nip);
                this.appendBoolFilterIfNonEmpty(params, 'showGuests', filters.showGuests);
                this.appendBoolFilterIfNonEmpty(params, 'partner', filters.partner, true);
                this.appendBoolFilterIfNonEmpty(params, 'partner', filters.partner, true);
                this.appendBoolFilterIfNonEmpty(params, 'sellWithWm', filters.sellWithWm, true);
                this.appendBoolFilterIfNonEmpty(params, 'notSellWithWm', filters.notSellWithWm, true);

            },
            load(options = {}) {
                if (this.loading) {
                    return;
                }

                this.loading = true;
                options = options || {};

                let filters = {};
                this.appendFilters(filters, options.filters || this.filters);
                this.filters = filters; // Remember them.

                const { page, itemsPerPage } = this.options;

                const params = {
                    ...filters,
                    offset: page > 1 ? itemsPerPage*(page-1) : 0
                };

                if (-1 !== itemsPerPage) {
                    params.limit = itemsPerPage;
                }

                params.companyType = this.companyType;

                api.get('/api/companies', {params})
                    .then((response) => {
                        this.companies = response.data.items;
                        this.total = response.data.total;

                        if (options.onSuccess) {
                            options.onSuccess();
                        }
                    })
                    .catch((error) => {
                        this.$root.$emit('notifyError', {
                            html: 'Nie udało się pobrać listy firm.',
                            error,
                        });
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getIsPremiumName(premium) {
                return getYesNoName(premium);
            },
            getIsPartnerName(partner) {
                return getYesNoName(partner);
            },
            async showAddCompanyModal() {
              this.$refs.addCompanyDialog
                  .open()
            },
            details(item) {
              this.$router.push({name: 'company-details', params: { id: item.id }}).catch(()=>{})
            },
            sendSms(item) {
              this.$refs.sendSmsDialog.open(item.id);
            },
            sendEmail(item) {
              this.$refs.sendEmailDialog.open(item.id);
            },
            notes(item) {
              this.$refs.addNoteDialog.open(item.id);
            },
            async disable(item) {
              await api.put(`/api/companies/${item.id}`, {disable: true});
              this.load();
            }
        },
        created() {
            getDatatableParams.call(this);
        }
    }
</script>

<style lang="css" scoped>
    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }
</style>